/**
 * Finishing - Typography
 *
 * JS pour la gestion des éléments textuels
 *
 * @since       06.07.2015
 * @version     1.0.0.2
 * @author      e-novinfo
 * @copyright   e-novinfo 2015
 */

/************************************/
/********** DOCUMENT READY **********/
/************************************/

jQuery(document).ready(function() {

    /********************************/
    /********** HYPHENATOR **********/
    /********************************/

    /*jQuery( "p, .hat-txt, .hat-txt-border" ).each(function() {
        jQuery( this ).addClass( "hyphenate" );
    });
    
    Hyphenator.run();*/

//END jQuery(document).ready
});
